import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { lazy, useEffect } from "react";
import { trackAnalyticsPage } from "@/shared/analytics/ga4";
import { ChatPage, ChatListPage } from "@/features/chat";
import {
  GamesPage,
  GameReviewPage,
  ProfilePage,
  SubscriptionPage,
  AnalysisPage,
  PatternsPage,
  LoginPage,
  ResetPasswordPage,
  SignupPage,
  AboutPage,
  NotFoundPage,
  TrendsPage,
  HelpPage,
} from "@/pages";
import { AuthLayout, GuestLayout } from "./layouts";
import { Layout } from "./Layout";

const BoardPage = lazy(() => import("@/features/board/playground/BoardPage"));
const HomePage = lazy(() => import("@/features/home").then((module) => ({ default: module.HomePage })));
const ArchivePage = lazy(() => import("@/features/archive").then((module) => ({ default: module.ArchivePage })));
const FocusPage = lazy(() => import("@/features/focus").then((module) => ({ default: module.FocusPage })));
const StudyPage = lazy(() => import("@/features/study").then((module) => ({ default: module.StudyPage })));
const SettingsPage = lazy(() =>
  import("@/features/preferences/SettingsPage").then((module) => ({ default: module.SettingsPage })),
);

const AnalyticsPageViews = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    trackAnalyticsPage(pathname);
  }, [pathname]);
  return null;
};

export const App = () => (
  <BrowserRouter>
    <AnalyticsPageViews />
    <Routes>
      <Route element={<GuestLayout />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/signup" element={<SignupPage />} />
      </Route>

      <Route element={<AuthLayout />}>
        <Route element={<Layout />}>
          <Route path="/" element={<Navigate to="/home" replace />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/games" element={<GamesPage />} />
          <Route path="/games/:id" element={<GameReviewPage />} />
          <Route path="/patterns" element={<PatternsPage />} />
          <Route path="/focus" element={<FocusPage />} />
          <Route path="/study" element={<StudyPage />} />
          <Route path="/trends" element={<TrendsPage />} />
          <Route path="/chats" element={<ChatListPage />} />
          <Route path="/chat" element={<ChatPage />} />
          <Route path="/analyze" element={<AnalysisPage />} />
          <Route path="/archive" element={<ArchivePage />} />
          <Route path="/board" element={<BoardPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/subscription" element={<SubscriptionPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/help" element={<HelpPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>
    </Routes>
  </BrowserRouter>
);
